<template>
  <div>
    <DemoLogin v-if="demoLogin"></DemoLogin>
    <KerberosLogin v-else-if="kerberosLogin"></KerberosLogin>
    <KeycloakLogin v-else-if="keycloakLogin"></KeycloakLogin>
    <div v-else>Fehler, konnte keine Authentifizierungsmethode ermitteln</div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import DemoLogin from "@/views/login/DemoLogin";
import KerberosLogin from "@/views/login/KerberosLogin";
import KeycloakLogin from "@/views/login/KeycloakLogin";

export default {
  name: "Login",
  components: {KerberosLogin, DemoLogin, KeycloakLogin},
  computed: {
    ...mapGetters('config', ['authType']),

    demoLogin() {
      return this.authType === "DEMO"
    },
    kerberosLogin() {
      return this.authType === "KERBEROS"
    },
    keycloakLogin() {
      return this.authType === "KEYCLOAK"
    }

  },

}
</script>

<style scoped>

</style>